import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    fetchSingleRecordSuccess,
    resetState
} from './roles.action';

import { Role } from './roles.model';

export interface RoleRecordsState {
    listData: Role[];
    loading: boolean;
    total: number;
    error: any;
    singleData: Role;
}

export const initialState: RoleRecordsState = {
    listData: [],
    loading: false,
    total: 0,
    error: null,
    singleData: null,
};


export const roleRecordReducer = createReducer(
    initialState,
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchRecordsSuccess, (state, { listData, total }) => {
        return { ...state, listData, total, loading: false };
    }),
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    on(fetchSingleRecordSuccess, (state, { singleData }) => {
        return { ...state, singleData, error: null };
    }),

    on(resetState, () => initialState)  // Reset action handler
    
    // addRecord
    // addRecordFailure
    // updateRecord
    // updateRecordSuccess
    // updateRecordFailure
    // deleteRecord
    // deleteRecordSuccess
    // deleteRecordFailure

    // on(addRecordSuccess, (state, { newData }) => {
    //     return { ...state, UserListdata: [newData, ...state.UserListdata], error: null };
    // }),

    // on(updateRecordSuccess, (state, { updatedData }) => {
    //     return { ...state, UserListdata: state.UserListdata.map((UserListdata) => UserListdata.id === updatedData.id ? updatedData : UserListdata), error: null };
    // }),

    // on(deleteRecordSuccess, (state, { id }) => {
    //     return { ...state, UserListdata: state.listData.filter((UserListdata) => UserListdata.id !== id), error: null }
    // }),
);